import { render, staticRenderFns } from "./TriggerAverageValue.vue?vue&type=template&id=c51a5e74&scoped=true&"
import script from "./TriggerAverageValue.vue?vue&type=script&lang=js&"
export * from "./TriggerAverageValue.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=c51a5e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a5e74",
  null
  
)

export default component.exports